import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormLandingComponent } from './form-landing/form-landing.component';
import { BuyWithin90Component } from './buy-within-90/buy-within-90.component';
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { OneToOneConsentComponent } from './one-to-one-consent/one-to-one-consent.component';
// import { RateTableAdsComponent } from './site-content/rate-table-ads/rate-table-ads.component';
// import { SiteContentComponent } from './site-content/site-content.component';
import { RatesFormComponent } from './rates-form/rates-form.component';
import { FormFlowShellComponent } from './form-flow-shell/form-flow-shell.component';
import { PremiumQuestionsComponent } from './premium-questions/premium-questions.component';

const routes: Routes = [
	{ path: 'buy-within-90/:id', component: BuyWithin90Component },
 	{ path: 'email-verification/:id', component: EmailVerificationComponent },
	{ path: 'email-completion/:id', component: EmailVerificationComponent, data: { type: 'abandonment' } },
	{ path: 'email-verification', component: EmailVerificationComponent },
	{ path: 'consent/:id', component: OneToOneConsentComponent },
	{ path: 'consent', component: OneToOneConsentComponent },
	{ path: 'premium-questions/:id', component: PremiumQuestionsComponent },
	{ path: 'premium-questions', component: PremiumQuestionsComponent },
	{ path: '', component: FormFlowShellComponent, children: [
		{ path: 'form-landing', component: FormLandingComponent },
		{ path: 'rates-form', component: RatesFormComponent },
	]},

	// !!! The most dangerous part any mistake here can bring problem with google conversion, cpc, leads !!!
	// { path: 'thank-you', loadChildren: () => import('./thank-you/thank-you.module').then(m=>m.ThankYouModule) }, // cpc/ad-search + get/consumer_info endpoints
	
	// @TODO: possible we have to re-orgnize this routes in separate module
	// { path: '', component: SiteContentComponent, children: [
	// 	{ path: 'mortgage-refinance-purchase-fha-va-jumbo-offers', component: RateTableAdsComponent },
	// 	{ path: 'mortgage-refinance-offers', component: RateTableAdsComponent },
	// 	{ path: '**', redirectTo: '/' }
	// ] },
  { path: '**', redirectTo: '/' }
];

@NgModule({
  imports: [
	RouterModule.forRoot(routes, {}),
  ],
  exports: [ RouterModule ],
})
export class AppRoutingModule { }
